/*
 * Keeps an accordion row where the shopper clicked it when it opens or closes.
 * Spec: docs/pdp-spec.md "Accordion rows keep their place (2026-11-03)".
 *
 * Why: on desktop the product info column is `position: sticky` (Dawn's enable_sticky_info) and
 * is taller than the viewport. When the page is scrolled to the end of the gallery the column is
 * held by its bottom edge, so opening a row makes it taller UPWARDS: the clicked summary moved
 * 409 px up on Aurora (1470x801) and the shopper landed at the bottom of the opened text.
 *
 * Fix: on a summary click inside the product info, remember where the summary sits in the
 * viewport; after the toggle, scroll the window by however far it moved. Runs once synchronously
 * in the toggle event, again after two animation frames and once more on a short timeout (the
 * timeout covers background tabs, where animation frames never fire). Nothing happens when the
 * summary did not move (mobile, or the column stuck at the top), so it is safe everywhere.
 */
(function () {
  'use strict';
  if (window.kardimaAccordionAnchor) return;
  window.kardimaAccordionAnchor = true;

  var SCOPE = '.product__info-container';
  var pending = null;

  function correct() {
    if (!pending || !pending.summary.isConnected) return;
    for (var i = 0; i < 3; i++) {
      var delta = pending.summary.getBoundingClientRect().top - pending.top;
      if (Math.abs(delta) < 1) return;
      window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target && event.target.closest ? event.target.closest('summary') : null;
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || details.tagName !== 'DETAILS' || !details.closest(SCOPE)) return;
      pending = { details: details, summary: summary, top: summary.getBoundingClientRect().top };
    },
    true
  );

  // `toggle` does not bubble, but a capturing listener on the document still sees it.
  document.addEventListener(
    'toggle',
    function (event) {
      if (!pending || event.target !== pending.details) return;
      var current = pending;
      correct();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (pending === current) correct();
        });
      });
      setTimeout(function () {
        if (pending === current) {
          correct();
          pending = null;
        }
      }, 120);
    },
    true
  );
})();
